import NotificationsIcon from '@mui/icons-material/Notifications'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff'
import { FC, useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { requestNotificationPermission } from 'handlers/showNewOrderNotification'

import { NotificationsIconButton } from './EnableNotificationsButton.styles'

/**
 * Кнопка в хедере: запрос разрешения на Browser Notification.
 * Показывает toast об успехе или отказе.
 */
const EnableNotificationsButton: FC = () => {
  const [permission, setPermission] = useState<NotificationPermission>(() => {
    if (typeof Notification === 'undefined') {
      return 'denied'
    }
    return Notification.permission
  })

  useEffect(() => {
    if (typeof Notification === 'undefined') {
      return
    }
    setPermission(Notification.permission)
  }, [])

  /**
   * Запрашивает разрешение и показывает результат в toast.
   */
  const handleEnableNotifications = async (): Promise<void> => {
    if (typeof Notification === 'undefined') {
      toast.error('Уведомления не поддерживаются в этом браузере')
      return
    }

    const nextPermission = await requestNotificationPermission()
    setPermission(nextPermission)

    if (nextPermission === 'granted') {
      toast.success('Уведомления о новых заказах включены')
      return
    }

    if (nextPermission === 'denied') {
      toast.error(
        'Уведомления запрещены. Разрешите их в настройках браузера.'
      )
      return
    }

    toast.info('Разрешение на уведомления не получено')
  }

  const NotificationStateIcon =
    permission === 'granted'
      ? NotificationsActiveIcon
      : permission === 'denied'
        ? NotificationsOffIcon
        : NotificationsIcon

  return (
    <NotificationsIconButton
      color='inherit'
      aria-label='Включить уведомления о новых заказах'
      title='Уведомления о новых заказах'
      onClick={() => {
        void handleEnableNotifications()
      }}
    >
      <NotificationStateIcon />
    </NotificationsIconButton>
  )
}

export default EnableNotificationsButton
